import React from "react";

const Modal: React.FC<any> = ({
  children,
  visible,
  closeModalHandler,
  className,
  Title,
  scroller,
  selectedYear,
}) => {
  // Format the content into an array of React elements
  const formattedContent = selectedYear?.content
    .split(/<br\s*\/?>/g) // Split on <br> or <br /> tags (case-insensitive)
    .map((item, index) => (
      <li key={index} className="text-gray-700">
        <span className="text-yellow-500">★</span> {item.trim()}
      </li>
    ));


  return (
    <>
      {visible && (
        <>
          <div
            id="account-modal"
            aria-hidden="true"
            className="fixed inset-0 z-50 flex items-center justify-center overflow-y-auto overflow-x-hidden"
          >
            <div className="relative w-full max-w-md md:max-w-3xl px-4 max-h-scrron mb-10">
              <div
                className={`relative bg-white rounded-2xl shadow-2xl p-6 ${scroller} max-h-screen overflow-y-scroll`}
              >
                <div
                  className={`flex justify-end items-center mb-4 ${className}`}
                >
                  <button
                    type="button"
                    className="text-gray-400 hover:bg-gray-200 hover:text-gray-900 rounded-full p-2 focus:outline-none"
                    onClick={closeModalHandler}
                  >
                    <svg
                      className="w-5 h-5"
                      fill="currentColor"
                      viewBox="0 0 20 20"
                      xmlns="http://www.w3.org/2000/svg"
                    >
                      <path
                        fillRule="evenodd"
                        d="M4.293 4.293a1 1 0 011.414 0L10 8.586l4.293-4.293a1 1 0 111.414 1.414L11.414 10l4.293 4.293a1 1 0 01-1.414 1.414L10 11.414l-4.293 4.293a1 1 0 01-1.414-1.414L8.586 10 4.293 5.707a1 1 0 010-1.414z"
                        clipRule="evenodd"
                      />
                    </svg>
                  </button>
                </div>

                {/* Modal Content */}
                <div className="flex flex-col items-center ">
                  <h2 className="text-lg md:text-2xl font-bold mb-4 text-gray-800">
                    Published In {selectedYear?.year}
                  </h2>
                  <ul className=" text-sm md:text-base space-y-2">
                    {formattedContent}
                  </ul>
                </div>
              </div>
            </div>
          </div>
          {/* Backdrop */}
          <div className="fixed inset-0 z-40 bg-black opacity-50"></div>
        </>
      )}
    </>
  );
};

export default Modal;
